export function getBrowserLocale(options = {}) {
  const defaultOptions = {
    languageCodeOnly: false,
  };

  const opt = {
    ...defaultOptions,
    ...options,
  };

  const browserLocale = window.navigator.language || window.navigator.userLanguage;

  if (!browserLocale) {
    return undefined;
  }

  return opt.languageCodeOnly
    ? browserLocale.split(/-|_/)[0]
    : browserLocale;
}
